function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "2.123%",
  x2: "50%",
  y2: "96.673%",
  id: "avatar_svg__53_a"
}, React.createElement("stop", {
  stopColor: "#B9DBF1",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#BAC6F7",
  offset: "100%"
})), React.createElement("ellipse", {
  id: "avatar_svg__54_b",
  cx: 12,
  cy: 12.444,
  rx: 7.556,
  ry: 7.111
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "url(#avatar_svg__53_a)",
  opacity: 0.34,
  cx: 12,
  cy: 12,
  r: 12
}), React.createElement("mask", {
  id: "avatar_svg__55_c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar_svg__54_b"
})), React.createElement("g", {
  mask: "url(#avatar_svg__55_c)",
  fill: "#7393BE",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(5.333 8)"
}, React.createElement("path", {
  d: "M13.271 13.662l-1.18-5.18c-.247-1.083-1.173-1.997-2.196-2.26-.75 1.029-1.916 1.692-3.229 1.692-1.312 0-2.478-.663-3.228-1.692-1.023.263-1.948 1.177-2.195 2.26l-1.18 5.18C-.232 14.948.54 16 1.775 16h9.782c1.235 0 2.006-1.052 1.713-2.338z"
}), React.createElement("circle", {
  cx: 6.667,
  cy: 3.111,
  r: 3.111
}))));

var SvgAvatar = function SvgAvatar(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgAvatar;